import { createSelector } from '@ngrx/store'
import { RootState } from '../root.model'

const errorLogState = (state: RootState) => state.errorLog

export const selectErrorLog = createSelector(errorLogState, state => state)

export const selectErrors = createSelector(errorLogState, state => state.errors)

export const selectErrorLogSize = createSelector(
  errorLogState,
  state => state.errors.length,
)
